import { Button, Icon } from "../Component";

const IconButton = ({ onClick, icon, className, size, color }) => {
  return (
    <Button className={`btn-round btn-icon ${className}`} type="button" color={color} size={size} onClick={onClick}>
      <Icon name={icon} />
    </Button>
  );
};

export default IconButton;
